// src/components/about/SectionHeader.styles.ts
// Shared header for the four light-surface content sections (domains,
// approach, capabilities, timeline).
//
// ClientCta deliberately does not use this: it renders on the inverted band, so
// its foreground/background pair is reversed and it needs its own treatment.
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { device } from '../../styles/breakpoints';

const sansStack = "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif";

export const SectionHeader = styled(motion.header)`
  max-width: 62ch;
  margin-bottom: ${({ theme }) => theme.spacing['2xl']};
`;

export const Eyebrow = styled.p`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin: 0 0 0.9rem;
  font-family: ${sansStack};
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const EyebrowMark = styled.span`
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  background: ${({ theme }) => theme.accent};
`;

export const Heading = styled.h2`
  margin: 0 0 0.9rem;
  font-family: ${sansStack};
  font-size: 2rem;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.text};

  @media ${device.mobile} {
    font-size: 1.6rem;
  }
`;

export const Lede = styled.p`
  margin: 0;
  font-family: ${sansStack};
  font-size: 1.02rem;
  line-height: 1.7;
  color: ${({ theme }) => theme.colors.secondary};
`;
